<template>
  <div class="tianmu-player-card">
    <div v-if="showLabel" class="play-status">
      {{ PLAY_STATUS[isPlaying] }}
    </div>

    <div class="play-button" @click.stop="handleClick">
      <img
        class="play-icon"
        :src="isPlaying === 1
          ? require('@/assets/img/tianmu/scenePause.png')
          : require('@/assets/img/tianmu/scenePlaying.png')"
      >
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n/i18n';

export default {
  name: 'TianMuPlayer',
  props: {
    name: {
      type: String,
      default: i18n.t('tianmu.devicePlaying'),
    },
    value: {
      // 0: 播放, 1: 暂停, 2: 停止
      type: [String, Number],
      default: 'pause',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  data(){
    const PLAY_STATUS = {
      0: this.$t('tianmu.devicePlaying'),
      1: this.$t('tianmu.paused'),
    }
    return{
      PLAY_STATUS,
      isPlaying:0
    }
  },
  methods: {
    handleClick() {
      this.isPlaying = this.isPlaying === 0 ? 1 : 0 
      this.$emit('clickPlayer',  this.isPlaying)
    },
  },
}
</script>

<style scoped lang="scss">
.tianmu-player-card {
}

.play-status {
  position: absolute;
  top: 30px;
  right: 6px;
  font-size: 15px;
  color: #333;
}

.play-button {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  color: #333;
}

.play-icon {
  width: 100%;
  height: 100%;
}
</style>
